var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._v(" "+_vm._s(_vm.$t(_vm.printerPackageInfo, { price: _vm.price }))+" "),_c('VFormBuilder',{ref:"form",attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"items.name.before",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('venue.form.deliveryAddress'))+" ")]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }